module.exports = __webpack_public_path__ + "static/media/smile.12ba72f0.png";